export default "__VITE_ASSET__40fa8cc8__"